import { render, staticRenderFns } from "./CheckboxStyled.vue?vue&type=template&id=4f62b7a6"
import script from "./CheckboxStyled.vue?vue&type=script&lang=js"
export * from "./CheckboxStyled.vue?vue&type=script&lang=js"
import style0 from "./CheckboxStyled.vue?vue&type=style&index=0&id=4f62b7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports